import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
@Component({
  selector: 'app-studyarea-logs',
  templateUrl: './studyarea-logs.component.html',
  styleUrl: './studyarea-logs.component.scss',
})
export class StudyareaLogsComponent implements OnInit {
  auditLogData: any[] = [];

  constructor(
    public config: DynamicDialogConfig) {
  }

  ngOnInit(): void {
    if (this.config?.data?.studyAreaData?.$values) {
      this.auditLogData = this.config?.data?.studyAreaData?.$values;
    }
  }

}
